import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-short-listed',
  templateUrl: './short-listed.component.html',
  styleUrls: ['./short-listed.component.scss']
})
export class ShortListedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
